module.exports = __webpack_public_path__ + "static/media/smHealthId.680089cd.png";